import type { TLang } from 'src/constants/langs'

interface ITextBtn {
    lang: TLang
    text: string
}

export const textBtn: ITextBtn[] = [
    {
        lang: 'ro',
        text: 'OBȚINEȚI BONUSUL',
    },
    {
        lang: 'de',
        text: 'BONUS BEANSPRUCHEN',
    },
    {
        lang: 'es',
        text: 'OBTENER BONO',
    },
    {
        lang: 'en',
        text: 'CLAIM BONUS',
    },
]
